// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"numberbox__visuallyhidden--oDzve","focusable":"numberbox__focusable--CUum3","numberbox":"numberbox__numberbox--faipZ"};